const ROUTES = {
  TERMS_AND_CONDITIONS: 'https://infina.vn/ho-tro/dau-tu/dieu-khoan-su-dung/',
  PRIVACY: 'https://infina.vn/ho-tro/dau-tu/chinh-sach-bao-mat/',
  JOBS: 'https://realstake.freshteam.com/jobs/',
  HOME: '/',
  CD_VERIFY: '/cd-verify',
  HIGH_GAIN: '/du-an',
  APP_DOWNLOAD: '/app-download',
  PROPERTY_LIST: '/du-an',
  GAIN_INCOME: '/gain',
  ABOUT_US: '/ve-chung-toi',
  INVESTMENT_OPTIONS: '/investment-options',
  TRADING: '/giao-dich',
  LOGIN: '/signin',
  SIGN_UP: '/signup',
  LOGOUT: '/sign-out',
  TRADING_SELL: '/giao-dich/sell',
  TRADING_BUY: '/giao-dich/buy',
  INVESTMENT_PORTFOLIO: '/investment-portfolio',
  MY_INVESTMENTS: '/investment-portfolio',
  INVITE_OTHERS: '/invite-others',
  UPDATE_PROFILE: '/profile',
  UPDATE_PROFILE_INFO: '/profile/info',
  UPDATE_ADDRESS: '/profile/address',
  UPDATE_BANK: '/profile/bank',
  UPDATE_PASSWORD: '/profile/password',
  VERIFY_IDENTITY: '/verify-identity',
  TRADING_ORDERS: '/trading/orders',
  FAQ: '/faqs',
  SIGN_IN: '/signin',
  REFERRAL: '/referral',
  FORGOT_PASSWORD: '/forgot-password',
  PROPERTY_DETAIL: '/dau-tu/:propertyName-rs:propertyId', // can-ho-thao-dien-rs12314
  BOOKING: '/booking/:id',
  PRESS: '/bao-chi',
  BLOG: '//infina.vn/blog',
  SUPPORT: '//infina.vn/ho-tro',
  REAL_ESTATE_INTRODUCTION: '/gioi-thieu-bat-dong-san',
  SAVING_INFO: 'https://www.infina.com.vn/tich-luy',
  MF_INFO: 'https://www.infina.com.vn/chung-chi-quy-mo',
  CD_INFO: 'https://www.infina.com.vn/chung-chi-tien-gui',
  STOCK_INFO: 'https://dautu.infina.vn/',
  YOUTUBE: 'https://www.youtube.com/channel/UCUXcWnwOEDXFEpAcs4iZ_dw',
  LINKED_IN: 'https://www.linkedin.com/company/realstake/',
  LAUNCH_INFINA: 'https://infina.vn/blog/ung-dung-dau-tu-va-tich-luy-infina-huy-dong-thanh-cong-2-trieu-usd-tu-5-quy-dau-tu-quoc-te/',
  FACEBOOK: 'https://www.facebook.com/infinavietnam',
}
const PROPERTY_CARD_LABELS = {
  HIGH_GAIN: 'highgain',
  VIEWS: 'views'
}

const HOTLINE = '08 9990 9928'
const EMAIL = 'hotro@infina.vn'
const ENV_STAGING = 'staging'
const ENV_LOCAL = 'local'
const ENV_PRODUCTION = 'production'

const SELL_REQUEST_STATUS = {
  ENDED: 'ended',
  STARTED: 'started',
  CANCELLED: 'cancelled',
}
const FEE_STATUS = {
  APPROVED: 'approved',
  NEW: 'new',
}

const BUY_REQUEST_STATUS = {
  NEW: 'new',
  ACCEPTED: 'accepted',
  FAILED: 'failed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
}

const LOGIN_REDIRECT_URL = 'LOGIN_REDIRECT_URL'
const LOCAL_STORAGE_PKG_KEY = 'bookingPkg'

// GA EVENT
const GA_EVENT_NAMES = {
  SOCIAL_SIGIN: 'SOCIAL_SIGIN'
}

module.exports = {
  ROUTES,
  GA_EVENT_NAMES,
  PROPERTY_CARD_LABELS,
  LOGIN_REDIRECT_URL,
  LOCAL_STORAGE_PKG_KEY,
  ENV_STAGING,
  ENV_LOCAL,
  ENV_PRODUCTION,
  SELL_REQUEST_STATUS,
  BUY_REQUEST_STATUS,
  FEE_STATUS,
  HOTLINE,
  EMAIL
}
